import styled from 'styled-components'

export const Main = styled.div`

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 960px;
    margin: 5rem auto;
    background: #c1bfbf;
    height: 200px;
`